// Shared "what's wrong with this session" badges (ADR 0119). Used by the global
// Neo sessions browser and the per-user section on the user detail page so both
// speak the same triage language. Colours come from .admin-badge-* in admin.css.

import { StatusBadge } from './StatusBadge';

// Mirrors the NeoSessionRow contract returned by /v1/admin/neo/sessions.
export interface NeoSessionRow {
  id: string;
  user_id: string;
  short_id: string;
  boat_id: string | null;
  created_at: string;
  last_message_at: string;
  message_count: number;
  total_cost_usd: number;
  has_refusal: boolean;
  has_thumbs_down: boolean;
  has_truncated: boolean;
  has_error: boolean;
  has_ungrounded: boolean;
  has_output_gate: boolean;
  needs_attention: boolean;
  /** A Try it guest's chat (TOM-950, ADR 0457). */
  try_it?: boolean;
}

const FLAGS: Array<{ key: keyof NeoSessionRow; status: string; label: string }> = [
  { key: 'has_refusal', status: 'rejected', label: 'refused' },
  { key: 'has_thumbs_down', status: 'failed', label: '👎' },
  { key: 'has_ungrounded', status: 'suggested', label: 'ungrounded' },
  { key: 'has_truncated', status: 'suggested', label: 'truncated' },
  { key: 'has_output_gate', status: 'rejected', label: 'suppressed' },
  { key: 'has_error', status: 'failed', label: 'error' },
];

export function NeoScentBadges({ row }: { row: NeoSessionRow }): React.ReactElement {
  const active = FLAGS.filter((f) => row[f.key] === true);
  if (active.length === 0) {
    return <StatusBadge status="published" label="ok" />;
  }
  return (
    <span className="neo-scent-badges">
      {active.map((f) => (
        <StatusBadge key={f.label} status={f.status} label={f.label} />
      ))}
    </span>
  );
}
